import * as signalR from '@microsoft/signalr';

const HUB_URL = process.env.REACT_APP_HUB_URL;

class SignalRService {
  constructor() {
    this.connection = null;
    this.callbacks = {
      voteUpdate: [],
      resultDeclared: [],
      candidateInfo: []
    };
  }

  async start() {
    if (this.connection) return;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL)
      .withAutomaticReconnect([0, 2000, 5000, 10000])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    // Register event handlers
    this.connection.on('ReceiveVoteUpdate', (update) => {
      this.callbacks.voteUpdate.forEach(cb => cb(update));
    });

    this.connection.on('ReceiveResultDeclared', (constituencyId, constituencyName) => {
      this.callbacks.resultDeclared.forEach(cb => cb(constituencyId, constituencyName));
    });

    this.connection.on('ReceiveCandidateInfo', (candidate) => {
      this.callbacks.candidateInfo.forEach(cb => cb(candidate));
    });

    this.connection.onreconnecting(() => {
      console.log('SignalR reconnecting...');
    });

    this.connection.onreconnected(() => {
      console.log('SignalR reconnected');
      this.joinAllUpdates();
    });

    this.connection.onclose(() => {
      console.log('SignalR disconnected');
    });

    try {
      await this.connection.start();
      console.log('SignalR connected');
      await this.joinAllUpdates();
    } catch (error) {
      console.error('SignalR connection error:', error);
      setTimeout(() => this.start(), 5000);
    }
  }

  async stop() {
    if (this.connection) {
      await this.connection.stop();
      this.connection = null;
    }
  }

  async joinAllUpdates() {
    if (this.connection?.state === signalR.HubConnectionState.Connected) {
      await this.connection.invoke('JoinAllUpdates');
    }
  }

  async joinConstituency(constituencyId) {
    if (this.connection?.state === signalR.HubConnectionState.Connected) {
      await this.connection.invoke('JoinConstituencyGroup', constituencyId);
    }
  }

  on(event, callback) {
    if (this.callbacks[event]) {
      this.callbacks[event].push(callback);
    }
  }

  off(event, callback) {
    if (this.callbacks[event]) {
      this.callbacks[event] = this.callbacks[event].filter(cb => cb !== callback);
    }
  }
}

export const signalRService = new SignalRService();
